import React from "react"

class HtmlEditor extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      htmlembed: props.htmlembed,
    }
  }

  getValue = () => {
    return {
      type: "html-embed",
      props: this.state,
    }
  }

  validate = () => {
    if (!this.state.htmlembed) {
      return false
    } else {
      return true
    }
  }

  handleInputChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    })
  }

  render() {
    return (
      <div style={{ margin: 10 }}>
        <div className="form-group">
          <label>Embedable code</label>
          <div className="form-group">
            <input
              onChange={this.handleInputChange}
              value={this.state.htmlembed}
              name="htmlembed"
              placeholder="eg: Please enter a Youtube embed code or other code that can be safely injected into the site."
              style={{ width: "100%" }}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default HtmlEditor
